function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.6666667 64c5.888 0 10.6666666-4.7786667 10.6666666-10.6666667v-10.6666666h-10.6666666c-5.88800003 0-10.6666667 4.7786666-10.6666667 10.6666666s4.77866667 10.6666667 10.6666667 10.6666667z",
  fill: "#0acf83"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 32c0-5.888 4.77866667-10.6666667 10.6666667-10.6666667h10.6666666v21.3333334h-10.6666666c-5.88800003 0-10.6666667-4.7786667-10.6666667-10.6666667z",
  fill: "#a259ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 10.6666667c0-5.88800003 4.77866667-10.6666667 10.6666667-10.6666667h10.6666666v21.3333333h-10.6666666c-5.88800003 0-10.6666667-4.7786666-10.6666667-10.6666666z",
  fill: "#f24e1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.3333333 0h10.6666667c5.888 0 10.6666667 4.77866667 10.6666667 10.6666667 0 5.888-4.7786667 10.6666666-10.6666667 10.6666666h-10.6666667z",
  fill: "#ff7262"
}), /*#__PURE__*/React.createElement("path", {
  d: "m42.6666667 32c0 5.888-4.7786667 10.6666667-10.6666667 10.6666667s-10.6666667-4.7786667-10.6666667-10.6666667 4.7786667-10.6666667 10.6666667-10.6666667 10.6666667 4.7786667 10.6666667 10.6666667z",
  fill: "#1abcfe"
}));

function SvgIconFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 43 64",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFigma);
export default __webpack_public_path__ + "static/media/icon-figma.95a30797.svg";
export { ForwardRef as ReactComponent };